export const users = [{
    id: 1,
    name: 'William',
    email: 'william@waavi.com',
    createdAt: '2020-01-10T09:48:57.000Z',
    updatedAt: '2020-01-10T09:48:57.000Z',
    role: 'admin',
}, {
    id: 2,
    name: 'Marcos',
    email: 'marcos@waavi.com',
    createdAt: '2020-01-10T11:17:30.000Z',
    updatedAt: '2020-01-10T11:17:30.000Z',
    role: 'admin',
}]

export default {
    users,
}
